import { useRef } from "react";
import Switch from "react-switch";
import { FormControl, Stack, Typography } from '@mui/material';

export const SwitchBoxClear = (props) => {
    const {
        label = "",
        id,
        name,
        checkText,
        uncheckText,
        disabled,
        fontColor = "#ffffff",
        onColor = "#8bc34a",
        offColor = "#ee3a0d",
        width = 130,
        value = true,
        setValue
    } = props;
    const elementRef = useRef(null);


    return (
        <FormControl component="fieldset" variant="standard">
            <Stack direction={"column"} justifyContent="flex-start" alignItems="center">
                {label && <Typography component="legend" className="react-switch-form-label">{label}</Typography>}
                <div className="react-switch-form" ref={elementRef}>
                    <Switch
                        id={id}
                        key={name}
                        name={name}
                        checked={value}
                        onChange={(e) => {
                            setValue(e)
                            if (props.onChange) {
                                props.onChange(e);
                            }
                        }}
                        handleDiameter={26}
                        offColor={offColor}
                        onColor={onColor}
                        height={28}
                        width={width}
                        disabled={disabled}
                        uncheckedIcon={<div style={{ color: fontColor }} className="react-switch-label-uncheck">{uncheckText}</div>}
                        checkedIcon={<div style={{ color: fontColor }} className="react-switch-label-check">{checkText}</div>}
                        className={"react-switch"}
                    />
                </div>
            </Stack>
        </FormControl>

    );
};
export default SwitchBoxClear;